function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export default function BackToTop() {
  return (
    <section className="back-to-top" aria-label="Back to top">
      <button type="button" className="back-to-top__btn" onClick={scrollToTop}>
        BACK TO TOP
      </button>
    </section>
  );
}
